<mat-sidenav-container>
  @if(site.id) {
    <mat-sidenav class="site-details-nav" position="end" [opened]="true" [disableClose]="true" mode="side">

      <mat-card appearance="outlined" class="rounded-0">
        <mat-card-content>
          @if(site.parent_site) {
            <ng-container>
              <h4 class="text-white">{{ utils.getLangTerm('sites.singular', 'Site') }} #{{ site.parent_site.id }}</h4>
              <p>
                <b>Name</b>: {{ site.parent_site.name }} <br>
                <b>Address</b>: {{ site.parent_site.location }} <br>
                <b>Created At:</b> {{ (site.parent_site.date_created * 1000) | timezoneConvertMedium }}
              </p>
            </ng-container>
          }

          <h4 class="text-white">{{ site.parent_site ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }} #{{ site.id }}</h4>
          <p>
            <b>Name</b>: {{ site.name }} <br>
            <b>Address</b>: {{ site.location }} <br>
            <b>Created At:</b> {{ (site.date_created * 1000) | timezoneConvertMedium }}
          </p>
        </mat-card-content>

        <mat-card-actions>
          @if(navCan.sendMessage) {
            <button mat-button (click)="composeNewMessage(site.id)" matTooltip="Click this button to send a message to users associated with this {{ site.parent_site ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }}.">
              <mat-icon>send</mat-icon>
              Send Message
            </button>
          }
        </mat-card-actions>
      </mat-card>

      <mat-nav-list class="pt-0" dense>
        @if(navCan.details) {
          <a mat-list-item routerLink="details" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Details</span>
          </a>
        }

        @if(navCan.noticeboard) {
          <a mat-list-item routerLink="noticeboard" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Noticeboard</span>
          </a>
        }

        @if(navCan.contractors) {
          <a mat-list-item routerLink="contractors" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">{{ utils.getLangTerm('contractors.plural', 'Contractors') }} (Sub-{{ utils.getLangTerm('safety-plans.abbreviation', 'Safety Plan') }}s)</span>
          </a>
        }

        @if(navCan.managers) {
          <a mat-list-item routerLink="managers" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Managers</span>
          </a>
        }

        @if(navCan.usersWorkedOn) {
          <a mat-list-item routerLink="users-worked-on" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Users Worked On</span>
          </a>
        }

        @if(navCan.mainSafetyPlan) {
          <a mat-list-item routerLink="sssp-config" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Main {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}</span>
          </a>
        }

        @if(navCan.forms) {
          <a mat-list-item routerLink="dynamic-forms" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Forms</span>
          </a>
        }

        @if(navCan.qrCodes) { 
          <a mat-list-item routerLink="codes" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">QR Codes</span>
          </a>
        }

        @if(navCan.documents) {
          <a mat-list-item routerLink="folders" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Documents</span>
          </a>
        }

        @if(navCan.assets) {
          <a mat-list-item routerLink="assets" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Asset Register</span>
          </a>
        }

        @if(navCan.hazards) {
          <a mat-list-item routerLink="hazards" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Hazards & Risks</span>
          </a>
        }

        @if(navCan.hazardousSubstances) {
          <a mat-list-item routerLink="hazardous-substances" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances') }}</span>
          </a>
        }

        @if(navCan.safetyObservations) {
          <a mat-list-item routerLink="safety-observations" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Safety Observations</span>
          </a>
        }

        @if(navCan.incidents) {
          <a mat-list-item routerLink="incidents" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Incidents</span>
          </a>
        }

        @if(navCan.toolboxTalks) {
          <a mat-list-item routerLink="toolbox-talks" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</span>
          </a>
        }

        @if(navCan.inspectionsAudits) {
          <a mat-list-item routerLink="audits" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Inspections & Audits</span>
          </a>
        }

        @if(navCan.taskAnalyses) {
          <a mat-list-item routerLink="task-analyses" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis Documents') }} <i>(Legacy)</i></span>
          </a>
        }

        @if(navCan.taJsaSwms) {
          <a mat-list-item routerLink="task-analyses-revised" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">{{ utils.getLangTerm('ta-jsa-swms.list.site-title', 'TA/JSA/SWMS Register') }}</span>
          </a>
        }

        @if(navCan.emergencyEvacuationPlans) {
          <a mat-list-item routerLink="emergency-evacuation-plans" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Emergency Evacuation Plans</span>
          </a>
        }

        @if(navCan.notifications) {
          <a mat-list-item routerLink="notifications" routerLinkActive="active-submenu-item">
            <span class="menu-panel-text">Notifications</span>
          </a>
        }
      </mat-nav-list>
    </mat-sidenav>
  }

  <section>
    <router-outlet></router-outlet>
  </section>
</mat-sidenav-container>

